import api from './api';
import { leftoverEditorHopUrl } from './apiRoot';

/**
 * Open the builder editor in a new tab.
 *
 * Mint the SSO URL first, then send that tab to it. Open the tab during the
 * click (not after await) so the browser allows it. Keep the window handle
 * so we can set the tab's location after mint. A blank tab with no handle
 * is what used to stay empty (ChurchConnect PR366).
 *
 * Falls back to this tab if a popup is blocked. Falls back to the plain
 * editor link on mint failure so the worst case is a password prompt —
 * never a button that does nothing.
 */
export async function openEditor(website, fallbackHref) {
  const tab = window.open('about:blank', '_blank');
  let href = fallbackHref;
  try {
    const id = website && website.id;
    if (id) {
      const res = await api.get(`/client/websites/${id}/editor-link`);
      if (res?.data?.url) href = res.data.url;
    }
  } catch (_) {
    /* fall through to the plain link */
  }
  const next = href ? leftoverEditorHopUrl(href) : '';
  if (!next) {
    if (tab) tab.close();
    return;
  }
  if (tab) {
    tab.location.replace(next);
    tab.focus();
    return;
  }
  window.location.href = next;
}
